import { BusinessCategoryGroup, Vertical } from './types';

type BusinessCategoryDefinition = {
  group: BusinessCategoryGroup;
  vertical?: Vertical;
};

const GASTRONOMY: BusinessCategoryDefinition = { group: 'GASTRONOMY', vertical: 'GASTRONOMY' };
const FRESH_PRODUCTS: BusinessCategoryDefinition = { group: 'FRESH_PRODUCTS' };
const RETAIL: BusinessCategoryDefinition = { group: 'RETAIL' };
const HEALTH_AND_BEAUTY: BusinessCategoryDefinition = { group: 'HEALTH_AND_BEAUTY' };

const BUSINESS_CATEGORY_DEFINITIONS = new Map<string, BusinessCategoryDefinition>([
  ['pizzeria', GASTRONOMY],
  ['empanadas', GASTRONOMY],
  ['hamburgueseria', GASTRONOMY],
  ['sushi', GASTRONOMY],
  ['parrilla', GASTRONOMY],
  ['pastas-caseras', GASTRONOMY],
  ['cafe-especialidad', GASTRONOMY],
  ['comida-mexicana', GASTRONOMY],
  ['comida-peruana', GASTRONOMY],
  ['comida-china', GASTRONOMY],
  ['comida-venezolana', GASTRONOMY],
  ['vegano', GASTRONOMY],
  ['brunch-desayunos', GASTRONOMY],
  ['pasteleria', GASTRONOMY],
  ['chocolateria', GASTRONOMY],
  ['donas-waffles', GASTRONOMY],
  ['cerveceria-artesanal', GASTRONOMY],
  ['cocteleria', GASTRONOMY],
  ['bubble-tea', GASTRONOMY],
  ['jugos-smoothies', GASTRONOMY],
  ['comida-rapida', GASTRONOMY],
  ['sangucheria', GASTRONOMY],
  ['restaurante', GASTRONOMY],
  ['panaderia', GASTRONOMY],
  ['heladeria', GASTRONOMY],
  ['rotiseria', GASTRONOMY],
  ['verduleria', FRESH_PRODUCTS],
  ['carniceria', FRESH_PRODUCTS],
  ['pescaderia', FRESH_PRODUCTS],
  ['fiambreria', FRESH_PRODUCTS],
  ['vinoteca-bebidas', FRESH_PRODUCTS],
  ['floristeria', FRESH_PRODUCTS],
  ['congelados', FRESH_PRODUCTS],
  ['almacen-kiosco', RETAIL],
  ['golosinas', RETAIL],
  ['supermercado', RETAIL],
  ['indumentaria-general', RETAIL],
  ['indumentaria-deportiva', RETAIL],
  ['lenceria', RETAIL],
  ['ropa-ninos', RETAIL],
  ['calzado', RETAIL],
  ['marroquineria', RETAIL],
  ['joyeria-bijouterie', RETAIL],
  ['hogar-deco-general', RETAIL],
  ['bazar', RETAIL],
  ['mueble', RETAIL],
  ['jardineria', RETAIL],
  ['celulares-accesorios', RETAIL],
  ['tecnologia-general', RETAIL],
  ['gaming', RETAIL],
  ['servicio-tecnico', RETAIL],
  ['vaperia', RETAIL],
  ['mayorista-descartables', RETAIL],
  ['limpieza', RETAIL],
  ['pet-shop', RETAIL],
  ['libreria-papeleria', RETAIL],
  ['ferreteria', RETAIL],
  ['pintureria-construccion', RETAIL],
  ['jugueteria', RETAIL],
  ['cotillon', RETAIL],
  ['repuestos', RETAIL],
  ['bicicleteria', RETAIL],
  ['pesca-camping', RETAIL],
  ['artesanias', RETAIL],
  ['cosmetica', HEALTH_AND_BEAUTY],
  ['perfumeria', HEALTH_AND_BEAUTY],
  ['unas', HEALTH_AND_BEAUTY],
  ['peluqueria-barberia', HEALTH_AND_BEAUTY],
  ['dietetica', HEALTH_AND_BEAUTY],
  ['farmacia', HEALTH_AND_BEAUTY],
  ['salud-belleza-general', HEALTH_AND_BEAUTY],
  ['suplementos-deportivos', HEALTH_AND_BEAUTY],
  ['optica', HEALTH_AND_BEAUTY],
]);

export const OTHER_BUSINESS_CATEGORY = 'otros';

export const BUSINESS_CATEGORY_GROUPS: BusinessCategoryGroup[] = [
  'GASTRONOMY',
  'FRESH_PRODUCTS',
  'RETAIL',
  'HEALTH_AND_BEAUTY',
];

export const BUSINESS_CATEGORIES: string[] = [...BUSINESS_CATEGORY_DEFINITIONS.keys()];

export const isBusinessCategory = (value: unknown): value is string =>
  typeof value === 'string' &&
  (value === OTHER_BUSINESS_CATEGORY || BUSINESS_CATEGORY_DEFINITIONS.has(value));

export const isConcreteBusinessCategory = (value: unknown): value is string =>
  typeof value === 'string' && BUSINESS_CATEGORY_DEFINITIONS.has(value);

export const getBusinessCategoryGroup = (
  businessCategory: string | null | undefined,
): BusinessCategoryGroup | null =>
  (businessCategory && BUSINESS_CATEGORY_DEFINITIONS.get(businessCategory)?.group) || null;

export const getBusinessCategoryVertical = (
  businessCategory: string | null | undefined,
): Vertical | null =>
  (businessCategory && BUSINESS_CATEGORY_DEFINITIONS.get(businessCategory)?.vertical) || null;
